var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn/trash@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.4686251,9.15634516 L21.5685593,9.15893092 C22.1060578,9.19843583 22.5176317,9.64099843 22.5291983,10.1690512 L22.5266126,10.2689854 L21.6305127,22.4505178 L21.6296431,22.5109105 C21.5684173,23.6048748 20.6917207,24.4810303 19.5978047,24.5422175 L19.475395,24.545632 L11.5239742,24.545632 C10.3736591,24.545632 9.43370626,23.6453451 9.37024971,22.5109056 L9.36880697,22.4505178 L8.47328227,10.2689854 C8.43377736,9.73148685 8.81140986,9.25963051 9.33209716,9.17098389 L9.43133554,9.15893092 C9.96883406,9.119426 10.4406904,9.4970585 10.529337,10.0177458 L10.54139,10.1169842 L11.437732,22.3124923 L11.4405211,22.3884929 C11.4405211,22.4253989 11.4644063,22.4566652 11.4975802,22.4676955 L11.5239742,22.4719459 L19.475395,22.4719459 C19.5125015,22.4719459 19.543984,22.4479003 19.5550927,22.4147906 L19.5593737,22.3884929 L19.5621629,22.3124923 L20.4585049,10.1169842 C20.4980098,9.57948566 20.9405724,9.16791179 21.4686251,9.15634516 Z M13.9660873,12.5191923 L13.9871972,12.6169057 L15.1437675,19.5510704 C15.2379771,20.1159001 14.8564642,20.6501571 14.2916345,20.7443668 C13.76003,20.8330347 13.2555073,20.5003012 13.1194479,19.9899471 L13.0983381,19.8922337 L11.9417678,12.9580691 C11.8475581,12.3932393 12.2290711,11.8589823 12.7939008,11.7647727 C13.3255053,11.6761048 13.830028,12.0088382 13.9660873,12.5191923 Z M18.2058363,11.7647727 C18.7374408,11.8534406 19.1066608,12.3319082 19.0697158,12.8587939 L19.0579694,12.9580691 L17.9013991,19.8922337 C17.8071894,20.4570635 17.2729324,20.8385764 16.7081027,20.7443668 C16.1764982,20.6556988 15.8072782,20.1772312 15.8442232,19.6503455 L15.8559697,19.5510704 L17.01254,12.6169057 C17.1067496,12.052076 17.6410066,11.670563 18.2058363,11.7647727 Z M6.53684303,9.0408608 C5.96421044,9.0408608 5.5,8.57665036 5.5,8.00401777 C5.5,7.46506944 5.91120371,7.02216289 6.43698813,6.97192111 L6.53684303,6.96717474 L10.784,6.967 L10.7782618,6.91372 L10.7733297,6.77069326 C10.7733297,5.51677191 11.7895032,4.5 13.0434973,4.5 L13.0434973,4.5 L17.9562925,4.5 C19.1411681,4.5 20.1236612,5.41077585 20.2215279,6.62766428 L20.2215279,6.62766428 L20.22646,6.77069326 C20.22646,6.83703477 20.2236156,6.90271082 20.2180421,6.96760613 L24.463157,6.96717474 C25.0357896,6.96717474 25.5,7.43138517 25.5,8.00401777 C25.5,8.54296609 25.0887963,8.98587264 24.5630119,9.03611442 L24.463157,9.0408608 L6.53684303,9.0408608 Z M17.9562925,6.57368606 L13.0434973,6.57368606 C12.9350418,6.57368606 12.8470158,6.66176388 12.8461708,6.7288425 L12.8461708,6.7288425 L12.8477071,6.78802209 C12.8558413,6.8882791 12.9410014,6.96717474 13.0434973,6.96717474 L13.0434973,6.96717474 L17.9562925,6.96717474 C18.0649849,6.96717474 18.1527739,6.87938571 18.1536188,6.81254244 L18.1536188,6.81254244 L18.1520821,6.75335438 C18.1439263,6.6528235 18.0585573,6.57368606 17.9562925,6.57368606 L17.9562925,6.57368606 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/trash",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#C1C1C1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-2)",
    fill: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.00ab53f108ef5e8feea5599d4ba47655.svg";
export { ForwardRef as ReactComponent };